import { render, staticRenderFns } from "./DetailsFacture.vue?vue&type=template&id=6911b7c2&scoped=true"
import script from "./DetailsFacture.vue?vue&type=script&lang=js"
export * from "./DetailsFacture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6911b7c2",
  null
  
)

export default component.exports